<template>
  <vl-properties-list v-vl-spacer:bottom.medium>
    <vl-properties-label>{{ $t('sourcespecification.detail.id') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.id }}</vl-properties-data>
    <vl-properties-label>{{ $t('sourcespecification.detail.label') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.label }}</vl-properties-data>
    <vl-properties-label>{{ $t('sourcespecification.detail.description') }}</vl-properties-label>
    <vl-properties-data>{{ props.detail.description }}</vl-properties-data>
  </vl-properties-list>
</template>

<script lang="ts" setup>
import { SourceSpecificationDetailDto } from '@/api/backoffice/clients';

const props = defineProps<{
  detail: SourceSpecificationDetailDto;
}>();
</script>
